import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import {
  getAllGroupNotification,
  getGroupNotification,
  updateGroupNotification,
} from "./slice";
import { NotificationGroupRequest } from "./api";

export const useAdminGeneral = () => {
  const state = useAppSelector((state) => state.adminGeneral);
  const dispatch = useAppDispatch();

  const getAllGroupNotificationHandler = useCallback(
    () => dispatch(getAllGroupNotification({})),
    [dispatch]
  );

  const getGroupNotificationHandler = useCallback(
    (group_type: string) => dispatch(getGroupNotification({ group_type })),
    [dispatch]
  );

  const updateGroupNotificationHandler = useCallback(
    (group_type: string, data: NotificationGroupRequest) =>
      dispatch(updateGroupNotification({ group_type, data })),
    [dispatch]
  );

  return {
    state,
    updateGroupNotification: updateGroupNotificationHandler,
    getGroupNotification: getGroupNotificationHandler,
    getAllGroupNotification: getAllGroupNotificationHandler,
  };
};
